export const facebook = {
  facebook: {
    shape:
      '<path fill="#3d3d3d" d="M17.3 16.68h2.91l.46-2.98H17.3v-1.63c0-1.23.4-2.33 1.55-2.33h1.85v-2.6C20.37 7.1 19.68 7 18.39 7c-2.71 0-4.3 1.44-4.3 4.72v1.98H11.3v2.98h2.79v8.18c.55.08 1.1.14 1.68.14a11.27 11.27 0 0 0 1.53-.12v-8.2z"/>',
    viewBox: [0, 0, 32, 32],
  },
};
